import { Form, IFormContext } from 'rewire-ui';

export class AreaSettingsDialogMembersViewModel {
  form:    Form;
  areaId?: string;

  constructor() {
    this.form = Form.create((form: IFormContext) => ({
      email: form.email().label('Email').validators('required').placeholder('enter email').autoFocus(),
    }));
  }

  reset() {
    this.form.reset();
    this.areaId = undefined;
  }

  load(areaId: string) {
    this.reset();
    this.areaId = areaId;
  }

  get isDisabled(): boolean {
    return false;
  }

  inviteToWorkSight() {
    if (this.isDisabled || !this.form.submit()) return false;
    // Send invite email to given email address with invites for given areas.
    return true;
  }
}

const areaSettingsDialogMembersViewModel = new AreaSettingsDialogMembersViewModel();
export default areaSettingsDialogMembersViewModel;
